import { render, staticRenderFns } from "./OperationsSvg.vue?vue&type=template&id=40db1e30"
import script from "./OperationsSvg.vue?vue&type=script&lang=js"
export * from "./OperationsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports